import type { NavIcon } from '@quadralize/ui'
import { cn } from '@quadralize/utils'
import { Calendar, HomeAngle, Magnifier, UserCircle } from '@solar-icons/react'
import { useTranslation } from 'react-i18next'
import { Link, useLocation } from 'react-router-dom'

interface NavItem {
  labelKey: string
  to: string
  icon: NavIcon
  matchPaths?: string[]
}

const NAV_ITEMS: NavItem[] = [
  { labelKey: 'nav.discover', to: '/', icon: HomeAngle, matchPaths: ['/'] },
  {
    labelKey: 'nav.search',
    to: '/buscar',
    icon: Magnifier,
    matchPaths: ['/buscar', '/quadra', '/reserva/sucesso'],
  },
  { labelKey: 'nav.reservations', to: '/reservas', icon: Calendar, matchPaths: ['/reservas'] },
  { labelKey: 'nav.profile', to: '/conta', icon: UserCircle, matchPaths: ['/conta'] },
]

function isItemActive(pathname: string, item: NavItem): boolean {
  if (item.to === '/') return pathname === '/'
  return Boolean(item.matchPaths?.some((p) => pathname.startsWith(p)))
}

export function AppBottomNav() {
  const { t } = useTranslation('play')
  const { pathname } = useLocation()
  const isBookingSuccess = pathname.startsWith('/reserva/sucesso')

  if (isBookingSuccess) {
    return null
  }

  return (
    <nav className="fixed bottom-0 left-0 right-0 z-30 border-t border-border-default bg-bg-base/90 pb-[env(safe-area-inset-bottom)] backdrop-blur-xl md:hidden">
      <ul className="flex items-center justify-around px-2">
        {NAV_ITEMS.map((item) => {
          const active = isItemActive(pathname, item)
          const ItemIcon = item.icon
          return (
            <li key={item.to} className="flex-1">
              <Link
                to={item.to}
                aria-current={active ? 'page' : undefined}
                className={cn(
                  'flex flex-col items-center gap-1 px-2 py-2.5 text-xs font-semibold transition-colors',
                  active ? 'text-primary' : 'text-text-tertiary',
                )}
              >
                <ItemIcon weight={active ? 'Bold' : 'Outline'} className="h-5.5 w-5.5" />
                <span>{t(item.labelKey)}</span>
              </Link>
            </li>
          )
        })}
      </ul>
    </nav>
  )
}
